import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ShieldStrokeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 1L3 6.45455V14.6364C3 22.2045 8.54667 29.2818 16 31C23.4533 29.2818 29 22.2045 29 14.6364V6.45455L16 1Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
